/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
export class Point {
  x: number;
  y: number;
  z: number;
}
